export const getStatusLabel = (row) => {
  const is_single_fastq = row?.fastq_file_id && !row?.fastq_pair_id
  const analyzeStatus = row?.analyses?.status ? row.analyses.status : null
  const annotationStatus = row?.annotations?.status ? row.annotations.status : null
  const is_annotated = row?.is_annotated

  if (analyzeStatus === 'VERIFYING') return 'VERIFYING'
  if (analyzeStatus === 'NOT_VERIFIED') return 'NOT_VERIFIED'
  if (analyzeStatus === 'FAILED') return 'FAILED'
  if (analyzeStatus === 'PENDING') return 'PENDING'
  if (analyzeStatus === 'RUNNING') return 'RUNNING'

  if (!is_annotated) {
    if (is_single_fastq) return 'SINGLE_FASTQ'
    return 'WAITING'
  }
  // if we're finished with annotating, return analysis status
  if (!annotationStatus || annotationStatus === 'DONE') return analyzeStatus
  return 'ANNO_' + annotationStatus
}

export const getBaseFileName = (filename) => {
  return (
    filename
      // Remove read pair indicators and extensions with a generic pattern
      .replace(/[._-]R?[12](?:_\d*)?\.f(ast)?q(\.gz)?$/, '')
      .replace(/\.clean/, '')
  )
}

export const isReadOne = (filename) => {
  return /[._-]R?1(?:_\d*)?\.f(ast)?q(\.gz)?$/.test(filename)
}

export const isReadTwo = (filename) => {
  return /[._-]R?2(?:_\d*)?\.f(ast)?q(\.gz)?$/.test(filename)
}

export const pairFastqFiles = (files) => {
  const pairs = new Map()

  files.forEach((file) => {
    if (!file.fastq_file_id) return // Skip non-FASTQ files

    const baseFileName = getBaseFileName(file.name)

    if (!pairs.has(baseFileName)) {
      pairs.set(baseFileName, { R1: null, R2: null })
    }

    const pair = pairs.get(baseFileName)
    if (isReadOne(file.name)) {
      pair.R1 = file
    } else if (isReadTwo(file.name)) {
      pair.R2 = file
    }
  })

  return Array.from(pairs.values())
    .filter((pair) => pair.R1 && pair.R2) // Only return complete pairs
    .map((pair) => ({
      fastq_pair_id: `${pair.R1.fastq_file_id}_${pair.R2.fastq_file_id}`,
      fastq_file_1: pair.R1,
      fastq_file_2: pair.R2,
      sample_name: getBaseFileName(pair.R1.name),
    }))
}

export const runTypeMapping = {
  WholeGenomeGermline: ['Whole Genome + Germline', 'WGS-G'],
  WholeGenomeTumorOnly: ['Whole Genome + Tumor Only', 'WGS-TO'],
  WholeGenomeTumorNormal: ['Whole Genome + Tumor Normal', 'WGS-TN'],
  WholeExomeGermline: ['Whole Exome + Germline', 'WES-G'],
  WholeExomeTumorOnly: ['Whole Exome + Tumor Only', 'WES-TO'],
  WholeExomeTumorNormal: ['Whole Exome + Tumor Normal', 'WES-TN'],
  ClinicalExomeGermline: ['Clinical Exome + Germline', 'CES-G'],
  ClinicalExomeTumorOnly: ['Clinical Exome + Tumor Only', 'CES-TO'],
  ClinicalExomeTumorNormal: ['Clinical Exome + Tumor Normal', 'CES-TN'],
}
